import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';
import { mainContentTabNav } from '@/routes/_app/main-content/main-content-tab-nav.css.ts';

export const profilePageContent = style({
  display: 'flex',
  flexDirection: 'column',
});

export const profilePageHeader = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  overflow: 'hidden',
  flex: `1 1 0%`,
});

export const emptyProfile = style([
  {
    justifyContent: 'start',
    margin: `${space.s70}px 0`,
  },
]);

export const profileNav = style([
  mainContentTabNav,
  responsiveStyle({
    mobile: {
      marginTop: space.s24,
      marginBottom: space.s20,
    },
    tablet: {
      marginTop: space.s35,
      marginBottom: space.s24,
    },
  }),
]);
